module.exports = __webpack_public_path__ + "img/12.fd7ace07.svg";